<app-nav-tab-bar
  *ngIf="(headerService.activeArtifactTab$ | async) === 'build'"
  [items]="menuItems"
  [config]="barConfig"
  [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS"
  (activeItemChange)="onActiveItemChange($event)"
></app-nav-tab-bar>
